import { AimWarn } from "#scripts/tools/aimlog.js";
import { scrollToBottom, addFeedbackButtons, extractMetaValue } from "#scripts/dialog/dialog_general.js";
import { checkNested, isMobile, urlParseCheck } from "#scripts/general_functions.js";
import { getAimData } from "#scripts/dialog/dialog_aim.js";
import { search } from "#scripts/dialog/dialog_search.js";
import { setContactArticle } from "#scripts/contact_functions.js";
import dayjs from "dayjs";
import language from "#scripts/translation";
import kariAnimator from "#scripts/kariavatar";
import { getMetadataValue } from "#scripts/search_haive";
import { addToMessageQueue, getMessageQueue } from "#scripts/dialog/stateManager.js";

// window.messagesToDisplay = [];

export const generateSearchLinks = (val) => {
	let res = "";

	if (checkNested(val, "payload", "index", "items", "results")) {
		// res += `<div class="dialog__fromkari dialog__fromkari__actionlinks dialog__searchresults">${language("I_ALSO_FOUND_THIS2")}<br/>`;
		res += `<div class="dialog__fromkari__actionlinks dialog__searchresults">`;
		const results = val.payload.index.items.results;
		for (const result of results) {
			if ("clientKey" in result) {
				// TellusR search result
				const id = result.contentId;
				const pagetype = result.contentTypeDisplayName;
				const url = result.isMedia === false ? `/artikkel/${id}` : result.href;
				const metaData = JSON.parse(decodeURIComponent(result.metaObject));

				switch (pagetype) {
					case "Kontaktkort":
						const contact = setContactArticle({
							name: result.title || "",
							email: metaData.personEpost || "",
							title: metaData.personStilling || "",
							phone: metaData.personMobil || "",
							wiredPhone: metaData.personTelefon || "",
							about: metaData.personFritekst || "",
							department: metaData.personAvdeling || "",
							image: result.thumbnail || metaData.imageContentId || ""
						});

						res += `
								<div data-searchid="${id}" class="searchresult__list__item" data-type="kontakt">
									<div class="searchresult__list__mal_visittkort">
										${contact}
									</div>
								</div>`;
						break;

					default:
						res += `<a href="${url}" 
                        data-searchid="${id}" 
                        class="dialog__fromkari__link normal dialog__fromkari__${pagetype}">${result.title}</a>`;
						break;
				}


			}
			else {
				const id = getMetadataValue(result, "ContentId");
				const pagetype = extractMetaValue(result.metadata, "PageTypeId");
				const url = `/artikkel/${id}`;
				switch (pagetype) {
					case "Kontaktkort":
						res += `<div data-searchid="${id}" class="normal dialog__fromkari__${pagetype}">${result.title}</div>`;
						break;
					default:
						res += `<a href="${url}" 
                        data-searchid="${id}" 
                        class="dialog__fromkari__link normal dialog__fromkari__${pagetype}">${result.title}</a>`;
						break;
				}
			}
		}
		res += "</div>";
	}
	return res;
};

export const generateActionLinks = (val) => {
	let res = '<div class="dialog__fromkari__actionlinks">';
	const urlGuid = /^(.*:)?(\{?([0-9a-fA-F]{8})-([0-9a-fA-F]{4})-([0-9a-fA-F]{4})-([0-9a-fA-F]{4})-([0-9a-fA-F]{12})\}?)$/gi;
	const countlinks = val.payload.links.length;

	for (const b of val.payload.links) {
		if (b.type === "action_link") {
			const phrase = getLastUserMessageText();
			if (b.text === "Søk på nettside") {
				res += `<a href="search/${phrase}?sok=${phrase}" class="dialog__fromkari__link dialog__fromkari__link--search">${b.text}</a>`;
			} else {
				res += `<button data-type="${b.type}" data-id="${b.id}" class=" dialog__fromkari__link">${b.text}</button>`;
			}
			if (b.text === "Snakk med min kollega?") {
				res += `<a href="search/${phrase}?sok=${phrase}" class="dialog__fromkari__link dialog__fromkari__link--search">Søk på nettsiden</a>`;
			}
		} else {
			let url = b.url;
			let target = b.link_target;
			const search = false;
			const download = b.url.match(/\.(pdf|doc|docx|xls|xlsx|odt|ppt|pptx|txt|ods)$/gi) ? "download" : "";
			let id = b.id;

			target = "normal";

			if (url.match(/aim:skjema:|skjema:/gi)) {
				target = "dialog__fromkari__mal_skjema";
				url = urlParseCheck(url);
				id = b.url.replace("aim:", "").replace("skjema:", "");
			} else if (url.match(/aim:/gim)) {
				target = "dialog__fromkari__mal_blokk";
				url = urlParseCheck(url);
				id = b.url.replace("aim:", "").replace("skjema:", "");
			}
			if (url.match(urlGuid) && countlinks === 1) {
				addSystemMessage("Fra nettsiden:");
				getAimData(url.split(":")[1]);
			} else {
				if (!url.match(/\.aim|\.kommune/gi)) {
					target = "_blank";
				}
				if (url.match(/^\//gim)) {
					target = "normal";
				}
				res += `<a data-href="${url}" data-id="${b.id}" data-aimid="${id}" 
                  ${search ? `data-search="${search}"` : ""} 
                  ${target === "_blank" ? `aria-label="${b.text} (${language("NAV_OPEN_I_NEW")})" target="_blank"` : ""} 
                  class="dialog__fromkari__link ${target} ${download}">${b.text}
                </a>`;
			}
		}
	}
	res += "</div>";

	return res;
};

function getLastUserMessageText () {
	const userMessages = document.querySelectorAll(".dialog__fromuser");
	if (userMessages.length === 0) return "";
	return userMessages[userMessages.length - 1].textContent.trim();
}

export const filterStopWords = (str) => {
	const stripThese = [
		"hvem",
		"hva",
		"hvor",
		"hvorfor",
		"hvordan",
		"Søk",
		"fordi",
		"så",
		"at",
		"dersom",
		"hvis",
		"som",
		"når",
		"da", // Subjunksjon
		"på",
		"under",
		"over",
		"gjennom",
		"mellom",
		"bak",
		"inni", // Preposisjon
		"og",
		"eller",
		"men",
		"for", // Konjunksjoner
		"meg",
		"deg",
		"ham",
		"han",
		"henne",
		"den",
		"det",
		"jeg",
		"eg",
		"du",
		"han",
		"hun",
		"ho",
		"den",
		"det",
		"vi",
		"me",
		"dere",
		"de",
		"dei",
		"oss",
		"dere",
		"dem",
		"dei", // pronomen
		"er",
		"har",
		"ny",
		"gammel",
		"passe", // verb
	];
	const puncts = ["\\?", "\\!", "\\.", "\\,"];
	const regex = new RegExp(`\\b${stripThese.join("\\b|\\b")}\\b|${puncts.join("|")}`, "gi");
	return str.replace(regex, "");
};

export const initBotInstance = () => {
	if (!sessionStorage.getItem("chat_sessionid") || sessionStorage.getItem("chat_sessionid") === "") {
		const filter = [];
		filter.push(window.serverdata.configMeta.aim.nameId);
		if (window.serverdata.configMeta.aim.lang === "nn") {
			filter.push("Nynorsk");
		}
		const bodyEl = document.body || document.getElementsByTagName("body")[0];
		const version = bodyEl?.dataset.version || "";
		filter.push(`Aim version: ${version}`);

		if (window.location.host === "localhost") {
			setTimeout(() => {
				if (!document.querySelector(".dialog__fromkari.dialog__start")) {
					const skip = Number.parseInt(window.serverdata.configMeta.aim.kariSkipStartMessages);
					if (skip !== 1) {
						addSystemMessage("Hei, jeg heter Kari og er kommunens chatbot. Jeg forstår best korte setninger med konkrete spørsmål.", "html", true, "dialog__start first");
					}
					if (skip !== 2) {
						addSystemMessage(
							'<b>Husk å ikke oppgi personlig info!</b> Ved å chatte med meg, samtykker du til <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/">personvernerklæringen</a>',
							"html",
							true,
							"dialog__start",
						);
					}
					if (skip !== 3) {
						addSystemMessage(language("INTRO_QUESTION"), "html", true, "dialog__start");
					}
				}
			}, 0);
			console.info("Fetch error in initBotInstance: Can't get kari dialog from localhost");

			processMessageQueue();
			return;
		}

		fetch("//007prokom.boost.ai/api/chat/v2", {
			method: "POST",
			mode: "cors",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				command: "START",
				filter_values: filter,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				sessionStorage.setItem("chat_sessionid", data.conversation.id);
				sessionStorage.setItem("chat_initialresponse", JSON.stringify(data.response.elements));
				sessionStorage.setItem("conversationHtml", "");

				let msgnr = 0;
				const skip = Number.parseInt(window.serverdata.configMeta.aim.kariSkipStartMessages);
				for (const b of data.response.elements) {
					const msgNrClass = msgnr === 0 ? "dialog__start first" : "dialog__start";
					if (skip - 1 !== msgnr) {
						addSystemMessage(b, b.type, true, msgNrClass);
					}
					msgnr++;
				}
			})
			.catch((error) => {
				if (error) {
					console.info("Fetch error in initBotInstance");
					AimWarn("Fetch error in initBotInstance", error);
				}
			});
	}

	processMessageQueue();

	if (!isMobile()) {
		setInterval(() => {
			if (window?.kariAnimator?.animateeWink !== undefined) {
				const avatarContainers = document.querySelectorAll(".dialog__avatarcontainer");
				if (avatarContainers.length > 0) {
					avatarContainers[0].innerHTML = window.kariAnimator.winkSvgHtml;
					window.kariAnimator.animateWink(1);
				}
			}
		}, 60000);
	}
};

export const toggleMessageLoader = (state = "start") => {
	if (state === "stop") {
		document.querySelectorAll(".removewhendone").forEach(el => el.remove());
	} else {
		setTimeout(() => {
			const dialogWindow = document.getElementById("kari__dialog__window");
			if (dialogWindow) {
				dialogWindow.insertAdjacentHTML("beforeend", addBotMessage());
				scrollToBottom();
			}
		}, 0);
	}
};

export const addSystemMessage = (val = "", type = "html", skipsave, msgClass) => {
	const payloadValue = typeof val === "string" ? val : val?.payload?.html;

	switch (type) {
		case "html":
			addToMessageQueue(
				addBotMessage(
					{
						type,
						payload: {
							html: payloadValue,
						},
					},
					skipsave,
					msgClass,
				),
			);
			break;

		default:
			addToMessageQueue(
				addBotMessage(
					{
						type,
						payload: val?.payload,
					},
					skipsave,
					msgClass,
				),
			);
			break;
	}

	if (!isMobile()) {
		setTimeout(() => {
			if (window?.kariAnimator?.animateHair !== undefined) {
				window.kariAnimator.animateHair(1);
			}
		}, 0);
	}
};

export const addBotMessage = (val, skipbuild, msgClass = "") => {
	let sval = JSON.parse(sessionStorage.getItem("conversation")) || false;
	const obj = { from: "kari", message: val };

	if (!sval) {
		sval = [obj];
	} else {
		sval.push(obj);
	}

	if (!skipbuild) {
		sessionStorage.setItem("conversation", JSON.stringify(sval));
	}

	let res = "";

	if (typeof val === "undefined") {
		return `
                <div class="dialog__message__container removewhendone">
                    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                </div>`;
	}

	let kari = "";

	if (msgClass && msgClass.match("first")) {
		kari = kariAnimator();
	}

	switch (val.type) {
		case "html":
			res = `<div class='dialog__fromkari ${msgClass}'><div class="dialog__avatarcontainer repeat">${kari}</div>${val.payload.html}</div>`;
			break;
		case "image": {
			const img = new Image();
			img.onload = () => {
				scrollToBottom();
			};
			img.src = val.payload.url;
			res = `<div class='dialog__fromkari__imagecontainer  ${msgClass}'>
                        <img src="${val.payload.url}" alt="${val.payload.alt_text}" class="dialog__fromkari__image">
                    </div>`;
			break;
		}
		case "vote":
			res = val.html;
			break;
		case "seperator":
			res = `<div class="dialog__seperator"><span class="dialog__seperator__text">${language("NEW_CONVERSATION")}</span></div>`;
			break;
		case "links":
			res = generateActionLinks(val);
			break;
		case "searchlinks":
			res += generateSearchLinks(val);
			break;
	}

	const returnHtml = `<div class="dialog__message__container">
                        ${res}
                      </div>`;

	if (!skipbuild) {
		sessionStorage.setItem("conversationHtml", (sessionStorage.getItem("conversationHtml") || "") + returnHtml);
	}

	return returnHtml;
};

export const addUserMessage = (_val, skipbuild) => {
	const val = _val; //.replace(/([0-9][[:blank:]]?){6,12}/gi, " ****(kryptert)");

	sessionStorage.setItem("lastmessage", dayjs().valueOf());

	let sval = JSON.parse(sessionStorage.getItem("conversation")) || false;
	const obj = { from: "user", message: val };

	if (!sval) {
		sval = [obj];
	} else {
		sval.push(obj);
	}

	if (!skipbuild) {
		sessionStorage.setItem("conversation", JSON.stringify(sval));
	}

	const returnHtml = `
            <div class="dialog__message__container text-right">
                <div class='dialog__fromuser'>
                ${val}
                </div>
            </div>
        `;

	if (!skipbuild) {
		sessionStorage.setItem("conversationHtml", (sessionStorage.getItem("conversationHtml") || "") + returnHtml);
	}
	return returnHtml;
};

export const messageJsonMap = (obj) => {
	if (checkNested(obj, "voidSearch")) {
		return "voidsearch";
	}
	if (checkNested(obj, "aim404")) {
		const guid = /^(\{?([0-9a-fA-F]{8})-([0-9a-fA-F]{4})-([0-9a-fA-F]{4})-([0-9a-fA-F]{4})-([0-9a-fA-F]{12})\}?)$/gi;

		let msg = getLastUserMessageText();

		if (msg.match(guid)) {
			getAimData(msg);
		} else {
			if (checkNested(obj, "searchKeywords")) {
				msg = obj.searchKeywords;
			}
			// IF NOT Guid
			search(msg);
		}
		return false;
	}
	if (checkNested(obj, "aimContent")) {
		getAimData(obj.aimContent);
	}
};

export const checkTemplateTypeSearch = (metadata) => {
	const result = metadata.filter((obj) => {
		return obj.name === "PageTypeId";
	});

	return result[0];
};

export const processMessageQueue = () => {
	let time = 0;
	const messageQueue = getMessageQueue();
	if (typeof messageQueue[0] === "string") {
		if (messageQueue[0]) {
			if (messageQueue[0].length < 10) {
				time = 0;
			} else if (messageQueue[0].length < 30) {
				time = 0;
			}
			toggleMessageLoader();
		}
	}

	setTimeout(() => {
		toggleMessageLoader("stop");

		if (messageQueue.length > 0) {
			if (typeof messageQueue[0] === "string") {
				const dialogWindow = document.getElementById("kari__dialog__window");
				if (dialogWindow) {
					dialogWindow.insertAdjacentHTML("beforeend", messageQueue[0]);
					scrollToBottom();
				}
				messageQueue.shift();
			} else if (typeof messageQueue[0] === "object") {
				const obj = messageQueue[0];
				if (obj.type === "feedback" && obj.data) {
					addFeedbackButtons(obj.data);
					messageQueue.shift();
				}
			} else {
				console.log("neither");
			}
		}
		processMessageQueue();
	}, time);
};

export const postMessageToBot = (val) => {
	let sanitizedInput = val.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
	sanitizedInput = stripHTMLTags(sanitizedInput);

	const dialogWindow = document.getElementById("kari__dialog__window");
	if (dialogWindow) {
		dialogWindow.insertAdjacentHTML("beforeend", addUserMessage(sanitizedInput));
	}
	scrollToBottom();

	// Load loader
	toggleMessageLoader();

	const guid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/gi;

	const msg = getLastUserMessageText();

	if (msg.match(guid)) {
		getAimData(msg);
	} else {
		const body = {
			command: "POST",
			type: "text",
			value: val,
		};

		const filter = [];

		filter.push(window.serverdata.configMeta.aim.nameId);

		if (window.serverdata.configMeta.aim.lang === "nn") {
			filter.push("Nynorsk");
		}
		const bodyEl = document.body || document.getElementsByTagName("body")[0];
		const version = bodyEl?.dataset.version || "";
		filter.push(`Aim version: ${version}`);

		body.filter_values = filter;

		if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
			body.conversation_id = sessionStorage.getItem("chat_sessionid");
		}

		// let voidSearch = !window.serverdata.configMeta.aim?.search?.searchResultInKari || false;
		// Disable search in kari only if explicitly set to false
		let voidSearch = window.serverdata.configMeta.aim?.search?.searchResultInKari === false;

		fetch("//007prokom.boost.ai/api/chat/v2", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(body),
		})
			.then((res) => res.json())
			.then((data) => {
				let msgnr = 0;

				document.querySelectorAll(".removewhendone").forEach(el => el.remove());

				for (const b of data.response.elements) {
					let msgNrClass = "";

					if (msgnr === 0) {
						msgNrClass = "first";
					}

					if (checkNested(b, "payload", "json")) {
						const r = messageJsonMap(b.payload.json);
						if (r === "voidsearch") voidSearch = true;
						if (r === false) return;
					} else if (checkNested(b, "payload", "style")) {
						const r = b.payload.style;
						if (r === "generated") voidSearch = true;
						addToMessageQueue(addBotMessage(b, false, msgNrClass));
					} else {
						addToMessageQueue(addBotMessage(b, false, msgNrClass));
					}
					scrollToBottom();

					msgnr++;
				}

				addToMessageQueue({ type: "feedback", data });

				if (!voidSearch) {
					const q = filterStopWords(val.toLowerCase());
					if (window.serverdata.configMeta.aim.lang === undefined) {
						window.serverdata.configMeta.aim.lang = "nb";
					}
					const searchLang = localStorage.getItem("currentLanguage") || `${window.serverdata.configMeta.aim.lang}_no`;

					const provider = window.serverdata.configMeta.aim?.search?.provider ? window.serverdata.configMeta.aim.search.provider : "tellusr";
					let query = "";
					let searchApiUrl = "";
					let queryFilter = "";
					let environment = "";
					let indexName = "";
					switch (provider) {
						case "haive":
							query = `query {      
															index {
																	items (
																			filter: {
																					searchQuery: "${q}",       
																					skip: 0,
																					take: 20,
																					queryType: MATCHALL,
																					sortBy: RELEVANCE,
																					categories: [
																							{ values: ["contentSubscribers", "${window.serverdata.configMeta.aim.clientId}"] },
																							{ values: ["Language", "${searchLang}"] }
																					]
																			}                 
																	)    
																	{
																			hits,results {
																					title, date, content, id, url, relevance, extracts, 
																					metadata {
																							name, value
																					},
																					categories {
																							values
																					}
																			}
																	}
															} 
													}`;
							searchApiUrl = window.searchEngine;
							fetch(searchApiUrl, {
								method: "POST",
								headers: {
									ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
									"Content-Type": "application/graphql",
								},
								body: query,
							})
								.then(res => res.json())
								.then(data => {
									if (checkNested(data.data, "index", "items", "results", "0")) {
										const result = data.data.index.items.results;
										if (result.length > 0 && result[0].relevance > 1000) {
											addSystemMessage(language("I_ALSO_FOUND_THIS"));
											const newOb = {
												data: {
													index: {
														items: {
															results: [result[0]],
														},
													},
												},
											};
											addToMessageQueue(addBotMessage({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"));
										}
									}
								});
							break;
						case "tellusr":
							queryFilter = `clientKey: (${window.serverdata.configMeta.aim.nameId}) AND `;
							if (window.serverdata.configMeta.aim.lang === undefined) {
								window.serverdata.configMeta.aim.lang = "nb";
							}
							queryFilter += `language: (${searchLang})`;
							if (window.serverdata.configMeta.aim?.search?.includeFiles === true) {
								queryFilter += ` AND isMedia:(true OR false)`;
							} else {
								queryFilter += ` AND isMedia:(false)`;
							}
							query = {
								q: q,
								hl: false,
								semanticWeight: window.serverdata.configMeta.aim?.search?.semanticWeight ?? 0.5,
								focus: window.serverdata.configMeta.aim?.search?.focus ?? 0,
								fq: queryFilter,
								sort: "score:desc",
								pageSize: 20,
								pageStart: 0,
								// facet: facets
							};

							environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
							indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`
							searchApiUrl = `https://prokom.tellusrapp.com/api/external/proxy/tellusr/api/v1/${indexName}/query`;

							fetch(searchApiUrl, {
								method: "POST",
								body: JSON.stringify(query),
								headers: {
									"Content-Type": "application/json",
									Authorization: `Basic ${btoa("tellusr:norske kommuner 2025")}`,
								},
							})
								.then((results) => results.json())
								.then((data) => {
									const result = data.results;
									if (result?.length > 0 && result[0].score > 0.8 && result[0]["score.regular"] !== undefined) {
										addSystemMessage(language("I_ALSO_FOUND_THIS"));
										const newOb = {
											data: {
												index: {
													items: {
														results: [result[0]],
													},
												},
											},
										};
										addToMessageQueue(addBotMessage({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"));
									}
								});
							break;
						default:
							queryFilter = `clientKey: (${window.serverdata.configMeta.aim.nameId}) AND `;
							if (window.serverdata.configMeta.aim.lang === undefined) {
								window.serverdata.configMeta.aim.lang = "nb";
							}
							queryFilter += `language: (${searchLang})`;
							if (window.serverdata.configMeta.aim?.search?.includeFiles === true) {
								queryFilter += ` AND isMedia:(true OR false)`;
							} else {
								queryFilter += ` AND isMedia:(false)`;
							}
							query = {
								q: q,
								hl: false,
								semanticWeight: window.serverdata.configMeta.aim?.search?.semanticWeight ?? 0.5,
								focus: window.serverdata.configMeta.aim?.search?.focus ?? 0,
								fq: queryFilter,
								sort: "score:desc",
								pageSize: 20,
								pageStart: 0,
								// facet: facets
							};

							environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
							indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`
							searchApiUrl = `https://prokom.tellusrapp.com/api/external/proxy/tellusr/api/v1/${indexName}/query`;

							fetch(searchApiUrl, {
								method: "POST",
								body: JSON.stringify(query),
								headers: {
									"Content-Type": "application/json",
									Authorization: `Basic ${btoa("tellusr:norske kommuner 2025")}`,
								},
							})
								.then((results) => results.json())
								.then((data) => {
									const result = data.results;
									if (result?.length > 0 && result[0].score > 0.8 && result[0]["score.regular"] !== undefined) {
										addSystemMessage(language("I_ALSO_FOUND_THIS"));
										const newOb = {
											data: {
												index: {
													items: {
														results: [result[0]],
													},
												},
											},
										};
										addToMessageQueue(addBotMessage({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"));
									}
								});
							break;
					}


				}
			})
			.catch((error) => console.error("Error: ", error));
	}
};

export const clickVote = (id, value) => {
	const filter = [];

	filter.push(window.serverdata.configMeta.aim.nameId);

	if (window.serverdata.configMeta.aim.lang === "nn") {
		filter.push("Nynorsk");
	}
	const bodyEl = document.body || document.getElementsByTagName("body")[0];
	const version = bodyEl?.dataset.version || "";
	filter.push(`Aim version: ${version}`);

	const body = {
		command: "POST",
		type: "feedback",
		conversation_id: sessionStorage.getItem("chat_sessionid"),
		id,
		value,
		filter_values: filter
	};

	if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
		body.conversation_id = sessionStorage.getItem("chat_sessionid");
	}

	fetch("//007prokom.boost.ai/api/chat/v2", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	}).then(() => { });
};

export const clickButtonAction = (id) => {
	const filter = [];

	filter.push(window.serverdata.configMeta.aim.nameId);

	if (window.serverdata.configMeta.aim.lang === "nn") {
		filter.push("Nynorsk");
	}
	const bodyEl = document.body || document.getElementsByTagName("body")[0];
	const version = bodyEl?.dataset.version || "";
	filter.push(`Aim version: ${version}`);

	const body = {
		command: "POST",
		type: "action_link",
		id,
		filter_values: filter
	};

	if (sessionStorage.getItem("chat_sessionid") && sessionStorage.getItem("chat_sessionid").length > 0) {
		body.conversation_id = sessionStorage.getItem("chat_sessionid");
	}

	fetch("//007prokom.boost.ai/api/chat/v2", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			command: "POST",
			type: "action_link",
			conversation_id: sessionStorage.getItem("chat_sessionid"),
			id,
			filter_values: filter
		}),
	}).then((res) => {
		res.json().then((data) => {
			for (const b of data?.response?.elements || []) {
				addToMessageQueue(addBotMessage(b));
				scrollToBottom();
			}
		});
	});
};

export function clickButtonUrl (el, evt) {
	// 1) Cancel the browser's default navigation.
	if (evt) {
		evt.preventDefault();
		evt.stopPropagation();            // avoid delegated handlers re-triggering
		evt.stopImmediatePropagation?.(); // belt + suspenders
	}

	// 2) Resolve target URL.
	const href =
		el.getAttribute?.('href') ||     // <a>
		el.dataset?.href ||              // <button data-href="...">
		el.href || '';

	if (!href) return false;

	// 3) Open the REAL URL *immediately* (keeps user-activation).
	//    Do this BEFORE any async or even sendBeacon/fetch calls.
	const popup = window.open(href, '_blank', 'noopener,noreferrer');

	// 4) Fire-and-forget analytics AFTER the tab is opened (no await).
	const id = el.dataset?.id;
	const filter = [];

	filter.push(window.serverdata.configMeta.aim.nameId);
	if (window.serverdata.configMeta.aim.lang === "nn") {
		filter.push("Nynorsk");
	}
	const bodyEl = document.body || document.getElementsByTagName("body")[0];
	const version = bodyEl?.dataset.version || "";
	filter.push(`Aim version: ${version}`);

	if (id) {
		const payload = {
			command: 'POST',
			type: 'external_link',
			id,
			filter_values: filter
		};
		const conv = sessionStorage.getItem('chat_sessionid');
		if (conv) payload.conversation_id = conv;

		try {
			const payloadString = JSON.stringify(payload);
			if (payloadString.length > 60000 && navigator.sendBeacon) {
				const blob = new Blob([payloadString], { type: 'application/json' });
				navigator.sendBeacon('https://007prokom.boost.ai/api/chat/v2', blob);
			} else {
				fetch('https://007prokom.boost.ai/api/chat/v2', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: payloadString,
					keepalive: true,
					mode: 'cors',
				}).catch(() => { });
			}
		} catch { }
	}

	// 5) If popup was blocked, fall back to same-tab.
	// if (!popup) window.location.assign(href);

	// Inline handlers: returning false cancels default too.
	return false;
}

const stripHTMLTags = (input) => {
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = input;
	return tempDiv.textContent || tempDiv.innerText || "";
};
